import React from 'react';
import { Link } from 'react-router-dom';

const NewFooter = () => {
  return (
    <footer className="relative border-t border-white/10 section-glass-alt">
      <div className="container-edge py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-4 space-y-4">
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group inline-flex items-center gap-3"
              aria-label="Kinesight — home"
            >
              <img
                src="/kinesight_logo.png"
                alt=""
                aria-hidden="true"
                className="h-7 w-auto select-none drop-shadow-[0_0_12px_rgba(0,212,170,0.25)] transition-transform duration-500 ease-out group-hover:scale-[1.04]"
                draggable={false}
              />
              <span className="font-display text-lg font-bold tracking-tight text-white uppercase">
                Kinesight
              </span>
            </Link>
            <p className="text-white/55 text-sm leading-relaxed max-w-sm">
              Source-level piracy defence for live sports, entertainment and
              media. Kinesight Limited is a subsidiary of Venture&nbsp;2 RDC Limited.
            </p>
          </div>

          <div className="md:col-span-5 space-y-4">
            <p className="font-mono text-[0.65rem] uppercase tracking-[0.35em] text-white/40">
              Contact
            </p>
            <a
              href="mailto:hello@kinesight.com"
              className="block font-display text-2xl md:text-3xl text-white hover:text-teal transition-colors tracking-tight"
            >
              hello@kinesight.com
            </a>
            <p className="text-mist-500 text-xs font-mono uppercase tracking-[0.3em]">
              Briefings · partnership · press
            </p>
          </div>

          <div className="md:col-span-3 flex md:justify-end">
            <div className="flex flex-col gap-3 items-start md:items-end">
              <Link
                to="/privacy"
                className="text-white/60 hover:text-teal transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <a
                href="https://venture2rdc.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-teal transition-colors text-sm"
              >
                Venture 2 RDC
              </a>
              <a
                href="https://www.linkedin.com/company/kinesight"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-teal transition-colors text-sm"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/35 text-xs font-mono uppercase tracking-[0.3em]">
          <span>© {new Date().getFullYear()} Kinesight Limited · a subsidiary of Venture 2 RDC Limited</span>
          <span>Built for broadcasters · rights holders · platforms</span>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
